import React from 'react'

const Storyboard = () => {
    return (
        <div className='board'>
        <div className='story_board'>
           <div className='plus'>+</div> 
           <span className='create'>Create Story</span>
           <span className='subtitle'>Share a photo or write something.</span>
        </div></div>
    )
}

export default Storyboard
